// Generated by purs version 0.15.15
import * as Ouroboros_Models_Brands_EmailDraft from "../Ouroboros.Models.Brands.EmailDraft/index.js";
import * as Ouroboros_Models_Brands_PasswordDraft from "../Ouroboros.Models.Brands.PasswordDraft/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var buildLoginViewProps = function (input) {
    return {
        emailValue: Ouroboros_Services_Clients_Interop_Option.map(Ouroboros_Models_Brands_EmailDraft.unwrap)(readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.auth.email))),
        passwordValue: Ouroboros_Services_Clients_Interop_Option.map(Ouroboros_Models_Brands_PasswordDraft.unwrap)(readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.auth.password))),
        onEmailChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.auth.email))(Ouroboros_Models_Brands_EmailDraft.makeEmailDraft(value));
        },
        onPasswordChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.auth.password))(Ouroboros_Models_Brands_PasswordDraft.makePasswordDraft(value));
        },
        onSubmit: function (v) {
            return Ouroboros_Programs_Capabilities.runControllerAction(input.kernel.controller.submit);
        },
        onNavigateToCreateAccount: function (v) {
            return Ouroboros_Programs_Capabilities.runControllerAction(Ouroboros_Programs_Capabilities.runNavigateAction(input.kernel.navigation.navigate)(input.kernel.navigation.createAccountRoute));
        },
        onNavigateToPasswordReset: function (v) {
            return Ouroboros_Programs_Capabilities.runControllerAction(Ouroboros_Programs_Capabilities.runNavigateAction(input.kernel.navigation.navigate)(input.kernel.navigation.passwordResetRoute));
        },
        onInit: Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Capabilities.runControllerAction(input.kernel.controller.onInit)),
        logoUri: input.logoUri,
        googleSsoStartUrl: input.googleSsoStartUrl
    };
};
export {
    buildLoginViewProps
};
//# sourceMappingURL=index.js.map
